import { useState } from "react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    const res = await fetch("/.netlify/functions/subscribe", {
      method: "POST",
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (res.ok) {
      setStatus("success");
      setEmail("");
    } else {
      setStatus("error");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="email"
        required
        placeholder="Unesite email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button type="submit">Prijavi se</button>

      {status === "success" && <p>Uspešno ste prijavljeni.</p>}
      {status === "error" && <p>Došlo je do greške.</p>}
    </form>
  );
}